<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="container">
      <!-- 简介 -->
      <div class="header-img">
        <div class="header-title">低代码赋能企业加快数字化转型步伐</div>
        <div class="header-desc">
          80%的企业与机构对业务需求的敏捷响应、高效低成本的开发与运维有着强烈的需求，而在这其中，越来越多企业与机构的领导者在IT建设以及数字化转型探索中，会考虑利用低代码/零代码产品用以支持技术人员、业务人员的敏捷实践。
        </div>
      </div>
      <!-- 热门文章 -->
      <div class="hotArticle-box">
        <div class="hotArticle-title">热门文章</div>
        <div class="hotArticle-swiper" v-show="isHotArticle">
          <van-swipe class="case-swipe" :width="175" :loop="false">
            <van-swipe-item
              v-for="item in articleHot"
              :key="item.id"
              @click="pushArticle(item, 291)"
            >
              <div class="case-item">
                <img
                  :src="'http://www.jxdinfo.com' + item.typeImg"
                  style="width: 100%"
                />
                <div class="title">{{ item.title }}</div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div
          class="hotArticle-swiper"
          v-show="!isHotArticle"
          style="display: flex; justify-content: center"
        >
          <van-loading color="#1989fa" />
        </div>
      </div>
      <!-- 全部文章 -->
      <div class="articleAll-box">
        <van-tabs animated @click="changeTab">
          <van-tab
            v-for="item in tabsData"
            :key="item.id"
            :title="item.name"
            :name="item.id"
          >
            <div class="articleMessage" v-show="isArticle">
              <div
                class="article"
                v-for="items in item.articleAll"
                :key="items.id"
                @click="pushArticle(items, item.channelId)"
              >
                <div class="article-box">
                  <div class="box-left">
                    <div class="left-title">
                      {{ items.title }}
                    </div>
                    <div class="left-content">
                      <div class="left-content-data">
                        {{ items.releaseDate.slice(0, 10) }}&nbsp;&nbsp;{{
                          items.releaseDate.slice(10, 18)
                        }}
                      </div>
                      <div class="left-content-icon">
                        <img src="../assets/img/frontierPhonePage/eye.png" />
                        <span>{{ items.contentCount }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="box-right">
                    <img
                      :src="'http://www.jxdinfo.com' + items.typeImg"
                      alt=""
                    />
                  </div>
                </div>
                <van-divider />
              </div>
              <van-pagination
                class="pagination"
                @change="pageChange($event, item)"
                v-model="tagArticleData.pageNo"
                :page-count="item.total"
                mode="simple"
                :show-page-size="5"
              >
                <template #prev-text>
                  <van-icon name="arrow-left" />
                </template>
                <template #next-text>
                  <van-icon name="arrow" />
                </template>
                <template #page="{ text }">{{ text }}</template>
              </van-pagination>
            </div>
            <div
              class="articleMessage"
              v-show="!isArticle"
              style="display: flex; justify-content: center"
            >
              <van-loading color="#1989fa" />
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- 右侧菜单 -->
    <RightMenu
      :isMenuShow="isMenuShow"
      @rightMenuShow="handleRightMenuShow"
    ></RightMenu>
    <!-- 底部立即体验弹出 -->
    <ExperienceNow
      :isPopShow="isPopShow"
      @CloseExperienceNow="handleCloseExperienceNow"
    ></ExperienceNow>
    <!-- 公司信息 -->
    <CompanyInformation @changePracticeMenuShow="handleOpenPractice">
    </CompanyInformation>
    <!-- Footer -->
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>
<script>
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import ExperienceNow from "./include/ExperienceNow";
import CompanyInformation from "./include/CompanyInformation";
import { getContentInfo } from "../api/frontierPage";
export default {
  name: "FrontierPhonePage",
  components: {
    PhoneHeader,
    PhoneFooter,
    RightMenu,
    ExperienceNow,
    CompanyInformation,
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
      articleHot: [], // 热门文章
      isArticle: false, // 文章loading
      isHotArticle: false, // 热门文章loading
      // tabs文章
      tagArticleData: {
        channelId: 291,
        pageSize: 10,
        sort: "contentCount",
      },
      // 热门文章
      hotArticleData: {
        channelId: 291,
        pageSize: 5,
        sort: "contentCount",
        pageNo: 1,
      },
      // tabs
      tabsData: [
        {
          id: 1,
          name: "全部文章",
          total: 0,
          channelId: 285,
          articleAll: [],
        },
        {
          id: 2,
          name: "新闻动态",
          total: 0,
          channelId: 291,
          articleAll: [],
        },
        {
          id: 3,
          name: "行业资讯",
          total: 0,
          channelId: 292,
          articleAll: [],
        },
      ],
    };
  },
  methods: {
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
    // 获取热门文章
    getContentInfo_channelId() {
      const self = this;
      getContentInfo(self.hotArticleData).then((res) => {
        if (res.status === 200) {
          self.articleHot = res.data.content;
          self.isHotArticle = true;
        } else {
          self.isHotArticle = false;
        }
      });
    },
    // 获取全部文章
    getContentInfo_All(page) {
      const self = this;
      page
        ? (self.tagArticleData.pageNo = page)
        : (self.tagArticleData.pageNo = 1);
      self.tagArticleData.channelId = 285;
      getContentInfo(self.tagArticleData).then((res) => {
        if (res.status === 200) {
          self.tabsData[0].channelId = 285;
          self.tabsData[0].articleAll = res.data.content;
          self.tabsData[0].total = Math.ceil(res.data.total / 10);
          self.isArticle = true;
        } else {
          self.isArticle = false;
        }
      });
    },
    // 获取行业资讯
    getContentInfo_industryMessage(page) {
      const self = this;
      page
        ? (self.tagArticleData.pageNo = page)
        : (self.tagArticleData.pageNo = 1);
      self.tagArticleData.channelId = 291;
      getContentInfo(self.tagArticleData).then((res) => {
        if (res.status === 200) {
          self.tabsData[1].channelId = 291;
          self.tabsData[1].articleAll = res.data.content;
          self.tabsData[1].total = Math.ceil(res.data.total / 10);
          self.isArticle = true;
        } else {
          self.isArticle = false;
        }
      });
    },
    // 获取技术干货
    getContentInfo_technologyMessage(page) {
      const self = this;
      page
        ? (self.tagArticleData.pageNo = page)
        : (self.tagArticleData.pageNo = 1);
      self.tagArticleData.channelId = 292;
      getContentInfo(self.tagArticleData).then((res) => {
        if (res.status === 200) {
          self.tabsData[2].channelId = 292;
          self.tabsData[2].articleAll = res.data.content;
          self.tabsData[2].total = Math.ceil(res.data.total / 10);
          self.isArticle = true;
        } else {
          self.isArticle = false;
        }
      });
    },
    // 分页
    pageChange(event, item) {
      const self = this;
      if (item.id === 1) self.getContentInfo_All(event);
      if (item.id === 2) self.getContentInfo_industryMessage(event);
      if (item.id === 3) self.getContentInfo_technologyMessage(event);
    },
    // 切换tab
    changeTab(name) {
      const self = this;
      if (name === 1) self.getContentInfo_All(1);
      if (name === 2) self.getContentInfo_industryMessage(1);
      if (name === 3) self.getContentInfo_technologyMessage(1);
    },
    // 跳转页面
    pushArticle(article, id) {
      let articleMessage = article;
      articleMessage.channelId = id;
      localStorage.setItem("article", JSON.stringify(articleMessage));
      this.$router.push({
        name: "FrontierDetailsPhoneArticle",
      });
    },
  },
  mounted() {},
  created() {
    const self = this;
    self.getContentInfo_channelId();
    self.getContentInfo_All();
    self.getContentInfo_industryMessage();
    self.getContentInfo_technologyMessage();
  },
};
</script>
<style scoped>
/* 简介 */
.container {
  margin-top: 53px;
  width: 100%;
  background: #f2f6f9;
}
.header-img {
  width: 100%;
  /* height: 100%; */
  background: url("../assets/img/frontierPhonePage/header-bg.png") no-repeat;
  background-size: cover;
}
.header-title {
  padding: 60px 20px 10px 20px;
  font-size: 0.4rem;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  color: #fff;
}
.header-desc {
  padding: 20px 20px 40px 20px;
  font-size: 0.25rem;
  font-weight: 500;
  color: #fff;
  line-height: 24px;
}
/* 简介end */
/* 热门文章 */
.hotArticle-swiper {
  margin-top: 20px;
}
.hotArticle-box {
  padding: 20px 10px;
  background: #fff;
}
.hotArticle-title {
  padding-left: 10px;
  font-size: 0.38rem;
  font-weight: bold;
}

.case-swipe {
  height: 170px;
}

.case-swipe >>> .van-swipe__indicators .van-swipe__indicator {
  background: #333333;
}

.case-swipe >>> .van-swipe__indicator--active {
  background-color: #1989fa !important;
}

.case-item {
  height: 100%;
  width: 90%;
}

.van-swipe-item {
  display: flex;
  justify-content: center;
}

.case-item > img {
  height: 80px;
}

.case-item > .title {
  margin: 0;
  font-size: 0.28rem;
  font-weight: 600;
}

.case-item > .text {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}
/deep/ .van-swipe__indicators {
  display: none;
}
/* 热门文章end */
/* 全部文章tab */
.articleAll-box {
  background: #fff;
}
.article-box {
  padding: 20px;
  display: flex;
  width: 100%;
}
.box-left {
  width: 60%;
  padding-right: 10px;
}
.left-title {
  line-height: 25px;
  font-size: 16px;
  font-weight: 500;
  height: 85px;
  color: #2e2e2e;
}
.left-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left-content-data {
  color: #a7a7a7;
}
.left-content-icon {
  display: flex;
  align-items: center;
  color: #a7a7a7;
}
.left-content-icon img {
  width: 19px;
  height: 13px;
}
.left-content-icon span {
  margin: 0 10px 0 5px;
}
.box-right {
  width: 40%;
  height: 100px;
}
.box-right img {
  width: 100%;
  height: 100%;
}
.pagination {
  margin: 20px;
}
.van-divider {
  margin: 0;
  padding: 0 20px;
}
/* tab栏下方滑块 */
/deep/ .van-tabs__line {
  width: 60px;
  background-color: #186cf5 !important;
  height: 1.5px;
}
/* tab栏文字 */
/deep/ .van-tab__text--ellipsis {
  font-size: 17px;
  font-weight: 500;
}
/* 全部文章tab end */
</style>



// WEBPACK FOOTER //
// src/components/FrontierPhonePage.vue